import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

// 自定义 SVG 图标组件示例
// 你可以直接从项目中的 SVG 文件导入或在这里定义

// 示例：Home 图标
const HomeSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 6.33333L8 2L14 6.33333V13.3333C14 13.5101 13.9298 13.6797 13.8047 13.8047C13.6797 13.9298 13.5101 14 13.3333 14H2.66667C2.48986 14 2.32029 13.9298 2.19526 13.8047C2.07024 13.6797 2 13.5101 2 13.3333V6.33333Z"
      stroke="currentColor"
    />
    <path d="M6 14V8H10V14" stroke="currentColor" />
  </svg>
);

const CanvasSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 11.3336C3.33333 8.66695 4.66667 7.33362 6 8.66695C7.33333 10.0003 8.66667 12.667 10 10.0003C11.3333 7.33362 12.6667 6.00029 14 7.33362"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M2 4.66699H14M2 8.00033H14"
      stroke="currentColor"
      strokeOpacity="0.3"
      strokeLinecap="round"
    />
  </svg>
);

const ClientsSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 6.66699C7.10457 6.66699 8 5.77156 8 4.66699C8 3.56242 7.10457 2.66699 6 2.66699C4.89543 2.66699 4 3.56242 4 4.66699C4 5.77156 4.89543 6.66699 6 6.66699Z"
      stroke="currentColor"
    />
    <path
      d="M2 13.333C2 11.1237 3.79067 9.33301 6 9.33301C8.20933 9.33301 10 11.1237 10 13.333"
      stroke="currentColor"
    />
    <path
      d="M11.3337 6.33333C12.2541 6.33333 13.0003 5.58714 13.0003 4.66667C13.0003 3.74619 12.2541 3 11.3337 3C10.4132 3 9.66699 3.74619 9.66699 4.66667C9.66699 5.58714 10.4132 6.33333 11.3337 6.33333Z"
      stroke="currentColor"
      strokeOpacity="0.5"
    />
    <path
      d="M13.333 13.3333C13.333 11.4927 11.9897 10 10.333 10"
      stroke="currentColor"
      strokeOpacity="0.5"
      strokeLinecap="round"
    />
  </svg>
);

const PlanningSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2H3.33333C2.59695 2 2 2.59695 2 3.33333V6C2 6.73638 2.59695 7.33333 3.33333 7.33333H6C6.73638 7.33333 7.33333 6.73638 7.33333 6V3.33333C7.33333 2.59695 6.73638 2 6 2Z"
      stroke="currentColor"
    />
    <path
      d="M12.667 2H10.0003C9.26395 2 8.66699 2.59695 8.66699 3.33333V6C8.66699 6.73638 9.26395 7.33333 10.0003 7.33333H12.667C13.4034 7.33333 14.0003 6.73638 14.0003 6V3.33333C14.0003 2.59695 13.4034 2 12.667 2Z"
      stroke="currentColor"
    />
    <path
      d="M6 8.66699H3.33333C2.59695 8.66699 2 9.26395 2 10.0003V12.667C2 13.4034 2.59695 14.0003 3.33333 14.0003H6C6.73638 14.0003 7.33333 13.4034 7.33333 12.667V10.0003C7.33333 9.26395 6.73638 8.66699 6 8.66699Z"
      stroke="currentColor"
    />
    <path
      d="M11.3337 8.66699V14.0003M8.66699 11.3337H14.0003"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

const FileSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.66699 2.66634C2.66699 2.31272 2.80747 1.97358 3.05752 1.72353C3.30756 1.47348 3.6467 1.33301 4.00033 1.33301H9.33366L13.3337 5.33301V13.333C13.3337 13.6866 13.1932 14.0258 12.9431 14.2758C12.6931 14.5259 12.3539 14.6663 12.0003 14.6663H4.00033C3.6467 14.6663 3.30756 14.5259 3.05752 14.2758C2.80747 14.0258 2.66699 13.6866 2.66699 13.333V2.66634Z"
      stroke="currentColor"
    />
    <path
      d="M9.33301 1.33301V5.33301H13.333M5.33301 8.66634H10.6663M5.33301 11.333H8.66634"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

const MeetingHubSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12 2.66699H4C2.89543 2.66699 2 3.56242 2 4.66699V11.3337C2 12.4382 2.89543 13.3337 4 13.3337H12C13.1046 13.3337 14 12.4382 14 11.3337V4.66699C14 3.56242 13.1046 2.66699 12 2.66699Z"
      stroke="currentColor"
    />
    <path
      d="M10.6667 1.33301V3.99967M5.33333 1.33301V3.99967M2 6.66634H14"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M6.0002 10.8002C6.44202 10.8002 6.8002 10.442 6.8002 10.0002C6.8002 9.55837 6.44202 9.2002 6.0002 9.2002C5.55837 9.2002 5.2002 9.55837 5.2002 10.0002C5.2002 10.442 5.55837 10.8002 6.0002 10.8002Z"
      fill="currentColor"
    />
    <path
      d="M10.0002 10.8002C10.442 10.8002 10.8002 10.442 10.8002 10.0002C10.8002 9.55837 10.442 9.2002 10.0002 9.2002C9.55837 9.2002 9.2002 9.55837 9.2002 10.0002C9.2002 10.442 9.55837 10.8002 10.0002 10.8002Z"
      fill="currentColor"
    />
  </svg>
);

const IntegrationSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke="currentColor"
    />
    <path
      d="M7.99967 1.33301V2.66634M7.99967 13.333V14.6663M2.81301 2.81301L3.75967 3.75967M12.2397 12.2397L13.1863 13.1863M1.33301 7.99967H2.66634M13.333 7.99967H14.6663M2.81301 13.1863L3.75967 12.2397M12.2397 3.75967L13.1863 2.81301"
      stroke="currentColor"
    />
  </svg>
);

const TeamSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 6.66699C9.10457 6.66699 10 5.77156 10 4.66699C10 3.56242 9.10457 2.66699 8 2.66699C6.89543 2.66699 6 3.56242 6 4.66699C6 5.77156 6.89543 6.66699 8 6.66699Z"
      stroke="currentColor"
    />
    <path
      d="M4 13.333C4 11.1237 5.79067 9.33301 8 9.33301C10.2093 9.33301 12 11.1237 12 13.333"
      stroke="currentColor"
    />
    <path
      d="M2.99967 7.00033C3.92015 7.00033 4.66634 6.25413 4.66634 5.33366C4.66634 4.41318 3.92015 3.66699 2.99967 3.66699C2.0792 3.66699 1.33301 4.41318 1.33301 5.33366C1.33301 6.25413 2.0792 7.00033 2.99967 7.00033Z"
      stroke="currentColor"
      strokeOpacity="0.5"
    />
    <path
      d="M1.33301 12.6664C1.33301 11.0097 2.37767 9.59974 3.83301 9.06641"
      stroke="currentColor"
      strokeOpacity="0.5"
      strokeLinecap="round"
    />
    <path
      d="M12.9997 7.00033C13.9201 7.00033 14.6663 6.25413 14.6663 5.33366C14.6663 4.41318 13.9201 3.66699 12.9997 3.66699C12.0792 3.66699 11.333 4.41318 11.333 5.33366C11.333 6.25413 12.0792 7.00033 12.9997 7.00033Z"
      stroke="currentColor"
      strokeOpacity="0.5"
    />
    <path
      d="M14.667 12.6664C14.667 11.0097 13.6223 9.59974 12.167 9.06641"
      stroke="currentColor"
      strokeOpacity="0.5"
      strokeLinecap="round"
    />
  </svg>
);

const TransactionHistorySvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
      stroke="currentColor"
    />
    <path
      d="M8 4.66699V8.00033L10.3333 9.33366"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33301 9.66699C5.33301 10.5875 6.52634 11.3337 7.99967 11.3337C9.47301 11.3337 10.6663 10.5875 10.6663 9.66699"
      stroke="currentColor"
      strokeOpacity="0.5"
      strokeLinecap="round"
    />
  </svg>
);

const EditSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="currentColor">
    <path
      d="M15.8906 4.49609C16.4644 4.49609 16.9297 4.96142 16.9297 5.53516C16.9297 6.10892 16.4644 6.57422 15.8906 6.57422H8.55762C7.10635 6.57422 5.92972 7.75089 5.92969 9.20215V18.9795C5.92969 20.4308 7.10634 21.6074 8.55762 21.6074H18.335C19.7862 21.6074 20.9629 20.4308 20.9629 18.9795V12.8682C20.9631 12.2946 21.4283 11.8301 22.002 11.8301C22.5755 11.8302 23.0408 12.2946 23.041 12.8682V18.9795C23.041 21.5783 20.9338 23.6855 18.335 23.6855H8.55762C5.95881 23.6855 3.85156 21.5783 3.85156 18.9795V9.20215C3.85159 6.60337 5.95883 4.49609 8.55762 4.49609H15.8906ZM21.3848 10.3223L11.9307 19.7676C11.8528 19.854 11.7404 19.8974 11.6279 19.8975H8.99609C8.75386 19.8974 8.56367 19.707 8.56348 19.4648V16.833C8.56349 16.7118 8.60683 16.608 8.69336 16.5215L18.1387 7.07617L21.3848 10.3223ZM17.334 9.59668C17.2147 9.47742 17.0217 9.47756 16.9023 9.59668L10.791 15.708C10.6718 15.8273 10.6717 16.0204 10.791 16.1396C10.9104 16.2582 11.1036 16.2586 11.2227 16.1396L17.334 10.0283C17.4529 9.90923 17.4525 9.716 17.334 9.59668ZM20.6494 4.56543C20.9871 4.228 21.5325 4.22786 21.8701 4.56543L23.8955 6.5918C24.2327 6.92947 24.233 7.47503 23.8955 7.8125L22.3115 9.39648L19.0645 6.14941L20.6494 4.56543Z"
      fill="currentColor"
    />
  </svg>
);

const CollapseClosedSvg = () => (
  <svg
    width="1.3em"
    height="1.3em"
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06"
      clipRule="evenodd"
    />
  </svg>
);

const CollapseOpenSvg = () => (
  <svg
    width="1.3em"
    height="1.3em"
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06"
      clipRule="evenodd"
    />
  </svg>
);

const LogoSvg = () => {
  return (
    <svg
      width="106"
      height="39"
      viewBox="0 0 106 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMid meet"
      style={{ width: "100%", height: "100%" }}
    >
      <rect
        x="5"
        y="6.09375"
        width="26.8125"
        height="26.8125"
        rx="13.4062"
        fill="#F7EEFB"
      />
      <path
        d="M16.1274 14.8711C13.642 14.8711 11.6266 16.8839 11.6266 19.3661H13.8782C13.8782 18.125 14.8847 17.1174 16.1299 17.1174H19.5061V14.8711H16.1299H16.1274Z"
        fill="#212121"
      />
      <path
        d="M16.1274 19.3657C13.642 19.3657 11.6266 21.3785 11.6266 23.8607H13.8782C13.8782 22.6196 14.8847 21.612 16.1299 21.612H19.5061V19.3633H16.1299L16.1274 19.3657Z"
        fill="#AD56D6"
      />
      <path
        d="M20.6344 21.6095H17.2581V23.8583H20.6344C23.1198 23.8583 25.1352 21.8455 25.1352 19.3633H22.8836C22.8836 20.6044 21.8771 21.612 20.6319 21.612L20.6344 21.6095Z"
        fill="#AD56D6"
      />
      <path
        d="M25.1326 14.8711H22.881C22.881 16.1122 21.8745 17.1198 20.6293 17.1198H17.2531V19.3685H20.6293C23.1148 19.3685 25.1302 17.3557 25.1302 14.8736L25.1326 14.8711Z"
        fill="#212121"
      />
      <g clipPath="url(#clip0_18356_9288)">
        <path
          d="M61.9154 16.1545V17.0665C61.6629 16.7947 61.3635 16.5697 61.0219 16.3893C60.5047 16.115 59.9157 15.9766 59.2574 15.9766C58.4531 15.9766 57.7304 16.1792 57.0895 16.5796C56.451 16.9825 55.9436 17.5238 55.5724 18.2059C55.2012 18.8881 55.0156 19.6543 55.0156 20.507C55.0156 21.3597 55.2012 22.1259 55.5724 22.808C55.9436 23.4902 56.451 24.029 57.0895 24.4244C57.7304 24.8199 58.4531 25.0176 59.2574 25.0176C59.9157 25.0176 60.5072 24.8817 61.0318 24.6073C61.3709 24.4294 61.6679 24.2069 61.9154 23.9375V25.0324H63.6131V16.1545H61.9154ZM61.507 22.635C61.0071 23.1886 60.3488 23.4655 59.5321 23.4655C58.9827 23.4655 58.4952 23.3369 58.0695 23.0824C57.6414 22.8253 57.3097 22.4768 57.0721 22.0319C56.8346 21.5871 56.7158 21.073 56.7158 20.4897C56.7158 19.9064 56.8346 19.4071 57.0721 18.9622C57.3097 18.5198 57.6389 18.1689 58.0596 17.9143C58.4803 17.6572 58.9654 17.5287 59.5123 17.5287C60.0592 17.5287 60.5394 17.6548 60.9477 17.9044C61.356 18.154 61.6778 18.505 61.9079 18.9548C61.9797 19.0908 62.0366 19.2366 62.0861 19.3873L62.0935 19.4343C62.1901 19.7606 62.2396 20.1189 62.2396 20.507C62.2396 20.9988 62.1628 21.4388 62.0094 21.8293V21.8466C61.8857 22.1358 61.7174 22.4002 61.507 22.635Z"
          fill="white"
        />
        <path
          d="M51.0336 22.4104L49.0439 16.1523H47.3882L45.3985 22.4104L43.634 16.1523H41.8125L44.6189 25.0303H46.1657L48.2173 18.5869L50.264 25.0303H51.8132L54.6196 16.1523H52.7957L51.0336 22.4104Z"
          fill="white"
        />
        <path
          d="M69.1332 22.7095L66.7772 16.1523H64.7553L68.2893 25.0303H70.0192L73.3701 16.1523H71.3853L69.1332 22.7095Z"
          fill="white"
        />
        <path
          d="M80.7407 16.1523L78.4886 22.7095L76.1326 16.1523H74.1107L77.6447 25.0303H79.3746L82.7255 16.1523H80.7407Z"
          fill="white"
        />
        <path
          d="M95.2846 17.8434C95.5346 17.6778 95.8068 17.5938 96.1038 17.5938C96.5913 17.5938 96.9947 17.6976 97.3164 17.9052C97.6382 18.1128 97.8807 18.3229 98.0465 18.5379L99.4176 17.5246C99.1206 17.1093 98.7098 16.751 98.1876 16.447C97.6654 16.1454 97.0343 15.9922 96.2993 15.9922C95.6806 15.9922 95.146 16.1108 94.6956 16.3481C94.2427 16.5854 93.8987 16.8993 93.6611 17.2922C93.4236 17.6828 93.3048 18.1178 93.3048 18.5923C93.3048 19.3881 93.5374 19.969 94.0002 20.3372C94.463 20.7055 95.1238 21.0021 95.9776 21.227C96.4404 21.3456 96.7967 21.4667 97.0467 21.5928C97.2966 21.7188 97.4724 21.8498 97.5713 21.9932C97.6728 22.1365 97.7223 22.3021 97.7223 22.4925C97.7223 22.7767 97.6184 23.0164 97.4105 23.2142C97.2026 23.4119 96.9081 23.5083 96.5295 23.5083C96.0543 23.5083 95.6682 23.4094 95.3712 23.2142C95.0743 23.0189 94.76 22.7001 94.4259 22.2626L93.0721 23.1524C93.4533 23.8395 93.9359 24.3264 94.5249 24.6106C95.1139 24.8948 95.7103 25.0382 96.3166 25.0382C96.8636 25.0382 97.3709 24.9294 97.8411 24.7095C98.3113 24.4895 98.69 24.1756 98.982 23.7653C99.274 23.355 99.4176 22.8657 99.4176 22.2972C99.4176 21.6447 99.1973 21.1207 98.7593 20.7228C98.3187 20.3249 97.5763 20.0011 96.5319 19.7539C95.9132 19.6106 95.49 19.4475 95.2574 19.2646C95.0248 19.0817 94.9109 18.8395 94.9109 18.5429C94.9109 18.2463 95.0347 18.0139 95.2846 17.8483V17.8434Z"
          fill="white"
        />
        <path
          d="M105.6 17.789V16.1528H103.746V14.1953H102.303L101.964 16.1528H100.628V17.789H101.964V22.2551C101.964 23.1919 102.187 23.8839 102.632 24.3288C103.078 24.7737 103.682 24.9961 104.441 24.9961C104.691 24.9961 104.907 24.9788 105.092 24.9418C105.275 24.9072 105.446 24.8651 105.6 24.8182V23.1622C105.481 23.1968 105.345 23.2265 105.189 23.2512C105.035 23.2759 104.857 23.2858 104.654 23.2858C104.392 23.2858 104.177 23.2018 104.003 23.0362C103.83 22.8706 103.746 22.6209 103.746 22.2898V17.789H105.6Z"
          fill="white"
        />
        <path
          d="M89.2089 23.0584C88.8277 23.355 88.2882 23.5033 87.5879 23.5033C86.8256 23.5033 86.2317 23.2685 85.806 22.7989C85.5461 22.5122 85.3704 22.1662 85.2714 21.7955L91.5228 20.1222L91.8445 20.0357C91.8223 19.7342 91.7777 19.4475 91.7109 19.1756C91.6589 18.9531 91.5921 18.7406 91.508 18.5379C91.456 18.402 91.3966 18.2735 91.3298 18.1474C90.9734 17.4702 90.4735 16.9437 89.8325 16.5631C89.1915 16.1825 88.4417 15.9922 87.5879 15.9922C86.734 15.9922 86.0015 16.1825 85.3605 16.5631C84.7171 16.9437 84.2196 17.4702 83.8633 18.1474C83.5069 18.8222 83.3287 19.618 83.3287 20.53C83.3287 21.442 83.5069 22.2206 83.8633 22.8978C84.2196 23.575 84.7171 24.099 85.3605 24.4722C86.0015 24.8454 86.7439 25.0332 87.5879 25.0332C88.5481 25.0332 89.3474 24.8454 89.9835 24.4722C90.6195 24.099 91.1392 23.5379 91.5426 22.7915L90.2062 21.9536C89.9216 22.3936 89.5875 22.7619 89.2089 23.0584ZM85.8233 18.1375C86.2614 17.6704 86.8504 17.4356 87.5879 17.4356C88.4194 17.4356 89.0356 17.7248 89.439 18.3056C89.5553 18.4712 89.6494 18.6541 89.7286 18.8469L85.1477 20.0728C85.1526 19.9739 85.1601 19.8775 85.17 19.7811C85.2269 19.183 85.4051 18.5849 85.8233 18.1375Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_18356_9288">
          <rect
            width="63.6582"
            height="11.071"
            fill="white"
            transform="translate(41.8125 13.9648)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// const DashboardSvg = () => (
//   <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
//     <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
//   </svg>
// );

export const HomeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HomeSvg} {...props} />
);

export const CanvasIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CanvasSvg} {...props} />
);

export const InvestorsIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ClientsSvg} {...props} />
);

export const CustomersIcon = InvestorsIcon;

export const PlanningIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PlanningSvg} {...props} />
);

export const FileHubIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FileSvg} {...props} />
);

export const MeetingIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MeetingHubSvg} {...props} />
);

export const TeamIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TeamSvg} {...props} />
);

// export const DashboardIcon = (props: Partial<CustomIconComponentProps>) => (
//   <Icon component={DashboardSvg} {...props} />
// );

export const SettingsIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IntegrationSvg} {...props} />
);

export const TransactionHistoryIcon = (
  props: Partial<CustomIconComponentProps>,
) => <Icon component={TransactionHistorySvg} {...props} />;

export const EditIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EditSvg} {...props} />
);

export const CollapseClosedIcon = (
  props: Partial<CustomIconComponentProps>,
) => <Icon component={CollapseClosedSvg} {...props} />;

export const CollapseOpenIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CollapseOpenSvg} {...props} />
);

export const CollapseIcon = CollapseOpenIcon;

export const LogoIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LogoSvg} {...props} />
);
